import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import QuestionPrompt from '../QuestionPrompt';//eslint-disable-line import/no-named-as-default
import DialogPrompt from '../DialogPrompt';
import Option from './OrderingMatchingOption';
import Button from '../../../buttons/Button';//eslint-disable-line import/no-named-as-default
import Feedback from './OrderingMatchingFeedback';
import Conversation from '../../conversationDialog/ChildConversationDialog';
import BadgeCollect from '../../badges/BadgeCollect';
import * as appDataActions from '../../../../actions/appDataActions';
import * as trackingDataActions from '../../../../actions/trackingDataActions';
import * as dialogPopupActions from '../../../../actions/dialogPopupActions';
import * as appHelper from '../../../../helpers/appHelper';
import * as dataHelper from '../../../../helpers/dataHelper';
import * as kpiHelper from '../../../../helpers/kpiHelper';
import * as userDataHelper from '../../../../helpers/userDataHelper';
import * as xAPIHelper from '../../../../helpers/xAPIHelper';
import * as dndHelper from '../../../../helpers/dndHelper';
import * as objectConstants from '../../../../constants/objectConstants';
import * as appConstants from '../../../../constants/appConstants';
import * as localStorage from '../../../../localStorage/localStorage';
import * as keyboardConstants from '../../../../constants/keyboardConstants';
import * as componentConstants from '../../../../constants/componentConstants';
import {ORDERING_MATCHING_REVIEW_CONFIG} from '../../../../models/dialogModels';
import _ from 'lodash';
import {DragDropContext, Draggable, Droppable} from 'react-beautiful-dnd';

class OrderingMatching extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            screenObject: this.props.screenObject,
            userData: this.props.userData,
            locale: appHelper.getLocalData(this.props.screenObject),
            options: [],
            currentOption: {},
            answers: Object.assign([],this.props.screenObject.options),
            reviewMode: false,
            propsUpdated: false,
            questionChecked: false,
            currentlyChecked: false,
            correctAnswerCount: this.props.screenObject.options.length,
            responseData: {
                bite_id: this.props.callbacks.getBiteId(),
                screen_id: this.props.callbacks.getScreenId(),
                asset_id: this.props.screenObject.asset_id,
                currentAttempt: 1,
                currentStatus: objectConstants.STATUS_NOT_STARTED,
                displayState: objectConstants.OBJECT_DISPLAY_STATE_INITIAL,
                outcome: {},
                responses: [],
                checkedOptions: [],
                userSelections: [],
                latestResponse: {},
                initialised: false,
                scoring_type: this.props.screenObject.scoring_type
            },
            showOptions: false,
            enableCheckBtn: false,
            showCheckBtn: true,
            showFeedback: false,
            skipFeedback: false,
            showResponse: false,
            revealedOptions: [],
            watchCheckBtnState: true,
            screenStatus: "",
            checkObjectStatus: false,
            handleCompletion: false,
            progressionHandled:false,
            checkPostXAPIResponse: false,
            checkedForMissedOptions: false,
            missedOptions:{
                show: false,
                options: []
            },
            character_name: appHelper.isDefined(this.props.callbacks) ? this.props.callbacks.getCharacterName() : appHelper.getScreenCharacterNameByAssetId(this.props.screenObject.asset_id),
            focusOnFeedback: false,
            showProgression: false,
            hideFeedback: false,
            progression_label:"",
            hasBadges: false,
            badgesCollected: false,
            animateBadge: true,
            allowShowFeedback: true,
            multiple_choice_question_label: appHelper.getLocaleString("multiple_choice_question_label"),
            submit_label: appHelper.getLocaleString("submit_label"),
            continue_label: appHelper.getLocaleString("continue_label"),
            try_again_label: appHelper.getLocaleString("try_again_label"),
            show_correct_answers_label:appHelper.getLocaleString("show_correct_answers_label"),
            show_my_answers_label:appHelper.getLocaleString("show_my_answers_label"),
            xApiResponseObj:{},
            showCorrectResponseControls: false,
            showUserResponses: true,
            labelWidth: 0,
            longestOption:{},
            usePreviousUserObjectData: true,
            isDragDisabled: false,
        };
        this.setOptions = this.setOptions.bind(this);
        this.randomiseAnswers = this.randomiseAnswers.bind(this);
        this.renderOptions = this.renderOptions.bind(this);
        this.onOptionClick = this.onOptionClick.bind(this);
        this.checkAnswers = this.checkAnswers.bind(this);
        this.showFeedback = this.showFeedback.bind(this);
        this.handleResponse = this.handleResponse.bind(this);
        this.handleProgression = this.handleProgression.bind(this);
        this.reattempt = this.reattempt.bind(this);
        this.onReviewObject = this.onReviewObject.bind(this);
        this.getObjectStatus = this.getObjectStatus.bind(this);
        this.setReviewMode = this.setReviewMode.bind(this);
        this.onOptionRevealed = this.onOptionRevealed.bind(this);
        this.setCheckBtnState = this.setCheckBtnState.bind(this);
        this.handleResponseComplete = this.handleResponseComplete.bind(this);
        this.postXAPIResponse = this.postXAPIResponse.bind(this);
        this.getStatusClass = this.getStatusClass.bind(this);
        this.onPanelClick = this.onPanelClick.bind(this);
        this.getMissedOptions = this.getMissedOptions.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.getTabIndex = this.getTabIndex.bind(this);
        this.onKeyboardPanelClick = this.onKeyboardPanelClick.bind(this);
        this.onFocusOnFeedback = this.onFocusOnFeedback.bind(this);
        this.handleSkipFeedback = this.handleSkipFeedback.bind(this);
        this.hasFeedbackToShow = this.hasFeedbackToShow.bind(this);
        this.enableProgression = this.enableProgression.bind(this);
        this.onProgressionClicked = this.onProgressionClicked.bind(this);
        this.onBadgeCollected = this.onBadgeCollected.bind(this);
        this.checkResponses = this.checkResponses.bind(this);
        this.setCurrentOption = this.setCurrentOption.bind(this);
        this.toggleUserAnswers = this.toggleUserAnswers.bind(this);
        this.onDragEnd = this.onDragEnd.bind(this);
        this.updateAnswersAfterDestination = this.updateAnswersAfterDestination.bind(this);
        this.updateAnswersAfterSource = this.updateAnswersAfterSource.bind(this);
        this.getCheckedOptions = this.getCheckedOptions.bind(this);
        this.setAllOptionsToAnswered = this.setAllOptionsToAnswered.bind(this);
        this.showOutcome = this.showOutcome.bind(this);
    }



    componentDidMount() {
        this.setOptions();
        //this.randomiseAnswers();
        if(localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
            this.checkResponses();
        }else{
            this.getObjectStatus();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.userData !== nextProps.userData) {
            this.setState({
                userData: Object.assign({}, nextProps.userData),
                checkObjectStatus: true
            });
        }

        if(this.state.lang !== nextProps.lang){
            let progression_label = "";
            if(this.state.progression_label === this.state.try_again_label){
                progression_label = appHelper.getLocaleString("try_again_label");
            }else if(this.state.progression_label ===  this.state.continue_label){
                progression_label = appHelper.getLocaleString("continue_label");
            }
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.screenObject),
                multiple_choice_question_label: appHelper.getLocaleString("multiple_choice_question_label"),
                submit_label: appHelper.getLocaleString("submit_label"),
                progression_label: progression_label,
                continue_label: appHelper.getLocaleString("continue_label"),
                try_again_label: appHelper.getLocaleString("try_again_label"),
                show_correct_answers_label:appHelper.getLocaleString("show_correct_answers_label"),
                show_my_answers_label:appHelper.getLocaleString("show_my_answers_label"),
                checkedForMissedOptions: true
            });
        }
    }

    componentDidUpdate() {
        if (this.state.propsUpdated && this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW) {
            this.setReviewMode();
        }

        if (this.state.watchCheckBtnState && !this.props.callbacks.isReviewMode()) {
            //console.log(`${this.state.revealedOptions.length} >= ${this.props.screenObject.options.length}`)
            this.setCheckBtnState(this.state.responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW);
        }

        if (this.state.skipFeedback) {
            this.handleSkipFeedback();
        }

        if (this.state.checkObjectStatus) {
            this.getObjectStatus();
        }

        if (this.state.handleCompletion && !this.state.progressionHandled) {
            this.handleProgression();
        }

        if (this.state.checkPostXAPIResponse) {
            this.postXAPIResponse();
        }

        if (this.state.checkedForMissedOptions) {
            this.getMissedOptions();
        }

        if (this.state.skipFeedback) {
            this.handleSkipFeedback();
        }

        if (this.state.focusOnFeedback){
            this.onFocusOnFeedback();
        }
    }

    onFocusOnFeedback(){
        let focusEl = document.getElementById(`feedback_wrapper_${this.state.screenObject.asset_id}`);
        if(appHelper.isDefined(focusEl) && focusEl !== null) {
            focusEl.focus();
        }
        this.setState({focusOnFeedback: false});
    }

    postXAPIResponse() {
        this.setState({checkPostXAPIResponse: false});
        let interactionData = xAPIHelper.setMatchingInteractionData(this.state.screenObject, this.state.options ,this.state.responseData);
        if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {

            let screen = appHelper.getScreenByAssetId(this.state.screenObject.asset_id);
            let category = {
                constant: this.state.screenObject.asset_type_code === componentConstants.MATCHING ? componentConstants.MATCHING : componentConstants.ORDERING,
                label: this.state.screenObject.asset_type_code === componentConstants.MATCHING ? componentConstants.MATCHING_LABEL : componentConstants.ORDERING_LABEL,
            };

            this.props.actions.postActvityStatement(screen, interactionData, category);
        }
    }

    handleSkipFeedback() {
        let selectedOptions = [];
        for (let i = 0; i < this.state.responseData.checkedOptions.length; i++) {
            let option = this.state.responseData.checkedOptions[i];
            selectedOptions = dataHelper.immutablePush(selectedOptions, option.selected_option.option_id);
        }

        let responseObj = {
            asset_id: this.state.screenObject.asset_id,
            selectedOptions: selectedOptions,
            kpis: !appHelper.isDefined(this.state.responseData.outcome.kpis) || this.state.responseData.outcome.kpis !== null ? this.state.responseData.outcome.kpis : [],
            indicators: appHelper.isDefined(this.state.responseData.outcome.indicators) && this.state.responseData.outcome.indicators !== null ? this.state.responseData.outcome.indicators : [],

        };

        this.setState({skipFeedback: false});
        //console.log(responseObj);
        //console.log(this.props.callbacks);
        this.props.callbacks.storeUserResponse(responseObj);

        if (appHelper.isDefined(this.props.callbacks.updateCharacterExpression) && appHelper.isDefined(this.state.responseData.outcome.character_pose)) {
            this.props.callbacks.updateCharacterExpression(this.state.responseData.outcome.character_pose);
        }

        if(!this.state.hasBadges) {
            let handleResponse = this.handleResponse;

            setTimeout(function () {
                handleResponse();
            }, 1000);
        }
    }

    setCheckBtnState(state) {
        if (this.state.responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW) {
            this.setState({showCheckBtn: state, watchCheckBtnState: false});
        }
    }

    //options functions
    setOptions(){
        let options = [];
        let answers = Object.assign([],dataHelper.randomiseArray(this.state.answers));
        let optionLabelLength = 0;
        let longestOption = this.state.screenObject.options[0];
        let state = this.state;
        _.forEach(this.state.screenObject.options, function (optionData, index) {
            let option = Object.assign({},optionData,{
                answered: false,
                is_correct: false,
                selected_option: answers[index],
            });
            options = dataHelper.immutablePush(options,option);


            if(state.screenObject.asset_type_code === componentConstants.MATCHING) {
                let optionLocale = appHelper.getLocalData(option);
                if(optionLocale.option.length > optionLabelLength){
                    optionLabelLength = optionLocale.option.length;
                    longestOption = Object.assign({},option);

                }
            }
        });

        this.setState({
            options: Object.assign([],options),
            currentOption: options[0],
            longestOption: Object.assign({},longestOption),
            showOptions: true
        });
    }

    randomiseAnswers() {
        if (this.state.screenObject.randomise_options) {
            this.setState({
                options: dataHelper.randomiseArray(this.state.answers),
                showOptions: true
            });
        } else {
            this.setState({showOptions: true});
        }
        this.props.callbacks.scrollToTop();
    }


    renderOptions() {
        if (!this.state.showOptions && this.state.responseData.currentStatus === objectConstants.STATUS_NOT_STARTED) {
            this.setState({showOptions: true});
        }

        this.props.callbacks.scrollToTop();
    }

    onOptionRevealed(option, labelWidth) {

        let index = appHelper.getArrayObjectIndexByKey(this.state.revealedOptions, "option_id", option.option_id);
        if (index === -1) {
            if(labelWidth > 0){
                this.setState(
                    {
                        labelWidth: labelWidth
                    }
                );
            }

            this.setState(
                {
                    revealedOptions: dataHelper.immutablePush(this.state.revealedOptions, option),
                    watchCheckBtnState: true,
                }
            );
        }
    }

    setCurrentOption(option){
        if(this.state.currentOption.option_id !== option.option_id){
            this.setState({
                currentOption: Object.assign({},option)
            });
        }
    }

    onOptionClick(from_option_id, answer) {
        let currentOption =  Object.assign({},this.state.currentOption);

        let options =  Object.assign([],this.state.options);

        let fromOption = appHelper.getArrayObjectByKey(options, "option_id", from_option_id);
        let fromOptionIndex = appHelper.getArrayObjectIndexByKey(options, "option_id", from_option_id);
        let fromOptionUpdated = false;

        let fromOptionSelection = Object.assign({},currentOption.selected_option);

        fromOption = Object.assign({},fromOption,{

            selected_option: fromOptionSelection,
            is_correct: fromOption.option_id === fromOptionSelection.option_id
        });

        //console.log(`fromOption`,fromOption);

        currentOption =  Object.assign({},this.state.currentOption,{
            selected_option: answer,
            answered: true,
            is_correct: currentOption.option_id === answer.option_id
        });

        //console.log(`currentOption`, currentOption);

        let optionIndex = appHelper.getArrayObjectIndexByKey(options, "option_id", currentOption.option_id);

        options = dataHelper.immutableSplice(options, optionIndex, 1, currentOption);
        //console.log(`options`,options);
        if(fromOption.option_id !== currentOption.option_id) {
            options = dataHelper.immutableSplice(options, fromOptionIndex, 1, fromOption);
        }
        //console.log(`options`,options);

        let checkedOptions = Object.assign([], this.state.responseData.checkedOptions);
        let checkedOptionIndex = appHelper.getArrayObjectIndexByKey(checkedOptions, "option_id", currentOption.option_id);
        if (checkedOptionIndex == -1) {
            checkedOptions = dataHelper.immutablePush(checkedOptions, currentOption);
        } else {
            checkedOptions = dataHelper.immutableSplice(checkedOptions, checkedOptionIndex, 1, currentOption);
        }

        if(fromOption.answered){
            let checkedFromOptionIndex = appHelper.getArrayObjectIndexByKey(checkedOptions, "option_id", fromOption.option_id);
            if (checkedFromOptionIndex == -1) {
                checkedOptions = dataHelper.immutablePush(checkedOptions, fromOption);
            } else {
                checkedOptions = dataHelper.immutableSplice(checkedOptions, checkedFromOptionIndex, 1, fromOption);
            }
         }

        if(checkedOptions.length === options.length - 1){
            let lastOption = {};
            let lastIndex = -1;
            for(let i = 0; i < options.length; i++){
                if(appHelper.isDefined(options[i]) && !options[i].answered){
                    lastOption = Object.assign({},options[i],{
                        answered: true,
                        is_correct: options[i].option_id === options[i].selected_option.option_id
                    });

                    lastIndex = i;
                    break;
                }

            }
            options = dataHelper.immutableSplice(options, lastIndex, 1, lastOption);
            checkedOptions = dataHelper.immutablePush(checkedOptions, lastOption);
        }

        let hasNextOption = appHelper.isDefined(options[optionIndex + 1]);

        checkedOptions.sort(function (a, b) {
            if (a.option_id < b.option_id) return -1;
            if (a.option_id > b.option_id) return 1;
            return 0;
        });

        //console.log(`checkedOptions`,checkedOptions);
        this.setState({
            options: Object.assign([],options),
            currentOption: hasNextOption ? options[optionIndex + 1] : currentOption,
            enableCheckBtn: checkedOptions.length  === options.length,
            responseData: Object.assign({}, this.state.responseData,
                {
                    checkedOptions: Object.assign([], checkedOptions),
                    initialised: true
                }
            )
        });
    }

    //interaction control

    showOutcome(){
        return !this.state.screenObject.hide_outcome || (this.state.screenObject.hide_outcome && this.state.screenObject.scoring_type === objectConstants.SCORING_TYPE_REFLECTIVE);
    }

    checkAnswers() {
        let correctAnswers = appHelper.getTypeCount(this.state.responseData.checkedOptions, "is_correct", true);
        let incorrectAnswers = appHelper.getNotOfTypeCount(this.state.responseData.checkedOptions,"is_correct", true);
        let outcome = {};
        if (correctAnswers.length === this.state.correctAnswerCount && incorrectAnswers.length === 0) {
            outcome = Object.assign({}, appHelper.getArrayObjectByKey(this.state.screenObject.outcomes, "result", "best"));
        } else {
            if (correctAnswers.length > 0) {
                outcome = Object.assign({}, appHelper.getArrayObjectByKey(this.state.screenObject.outcomes, "result", "ok"));
                if (!appHelper.isDefined(outcome.result)) {
                    outcome = Object.assign({}, appHelper.getArrayObjectByKey(this.state.screenObject.outcomes, "result", "poor"));
                }
            } else {
                outcome = Object.assign({}, appHelper.getArrayObjectByKey(this.state.screenObject.outcomes, "result", "poor"));
            }
        }

        if (this.state.screenObject.scoring_type === objectConstants.SCORING_TYPE_REFLECTIVE) {
            outcome = Object.assign({}, appHelper.getArrayObjectByKey(this.state.screenObject.outcomes, "result", "best"), {
                result: "reflective"
            });
        }

        let showResponse = false;
        if (appHelper.isDefined(outcome.dialogs) && outcome.dialogs.length > 0) {
            showResponse = true;
        }

        let hasBadges = appHelper.isDefined(outcome.badges) && outcome.badges.length > 0 && !outcome.enable_feedback  && !showResponse;
        let enable_feedback = outcome.enable_feedback && this.showOutcome();
        //console.log(`showProgression line 406`);
        this.setState({
            responseData: Object.assign({}, this.state.responseData,
                {
                    outcome: outcome,
                    displayState: objectConstants.OBJECT_DISPLAY_STATE_ANSWERED,
                }
            ),
            showResponse: showResponse,
            showFeedback: enable_feedback && !showResponse,
            focusOnFeedback: enable_feedback && !showResponse,
            skipFeedback: !enable_feedback && outcome.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN && !showResponse,
            showProgression: !enable_feedback && outcome.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN  && !showResponse && !hasBadges,
            progression_label: outcome.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN ? this.state.try_again_label :  this.state.continue_label,
            hasBadges: hasBadges,
            questionChecked: true,
            currentlyChecked: true,
            showCheckBtn: false,
            enableCheckBtn: false,
            showOptions: true,
            initialised: false,
            checkPostXAPIResponse: true,
            checkedForMissedOptions: true,
            isDragDisabled: true,
            showCorrectResponseControls: !showResponse && outcome.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN && outcome.result !== "best" && outcome.feedback_settings.show_correct_answers_controls && this.state.screenObject.scoring_type !== objectConstants.SCORING_TYPE_REFLECTIVE

        });
    }

    handleResponse() {
        this.setState({hideFeedback: false});
        let progressionRule = this.state.responseData.outcome.progression;

        let showResponse = false;
        if (appHelper.isDefined(this.state.responseData.outcome.dialogs) && this.state.responseData.outcome.dialogs.length > 0) {
            showResponse = true;
        }


        if (progressionRule === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN) {
            this.reattempt();
        } else {
            let show_feedback_after_completion = this.state.responseData.outcome.feedback_settings.show_feedback_after_completion;
            let showFeedbackOnceComplete = this.state.showFeedback && show_feedback_after_completion && this.state.responseData.outcome.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN && this.hasFeedbackToShow();
            this.setState(
                {
                    showFeedback: showFeedbackOnceComplete || (!this.props.callbacks.hasNextObject(this.props.index) && this.hasFeedbackToShow()),
                    focusOnFeedback:showFeedbackOnceComplete || (!this.props.callbacks.hasNextObject(this.props.index) && this.hasFeedbackToShow()),
                    showOptions: true,
                    options: Object.assign([], this.state.responseData.checkedOptions),
                    responseData: Object.assign(
                        {}, this.state.responseData,
                        {
                            currentStatus: objectConstants.STATUS_COMPLETE,
                            displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW,
                        }
                    ),
                    handleCompletion: true,
                }
            );
        }
    }

    hasFeedbackToShow(){
        let enable_feedback = this.state.responseData.outcome.enable_feedback && this.showOutcome();

        return enable_feedback;
    }

    handleProgression() {
        let enable_feedback = this.state.responseData.outcome.enable_feedback && this.showOutcome();

        let progressionRule = appHelper.isDefined(this.state.responseData.outcome.progression) ? this.state.responseData.outcome.progression : objectConstants.OBJECT_PROGRESSION_CONTINUE;
        let progressionType = appHelper.isDefined(this.state.responseData.outcome.progression_type) ? this.state.responseData.outcome.progression_type : undefined;
        let progressionGoToId = appHelper.isDefined(this.state.responseData.outcome.progression_goto_id) ? this.state.responseData.outcome.progression_goto_id : undefined;
        this.setState({handleCompletion: false, progressionHandled: true});
        let completionData = {
            progression: progressionRule,
            asset_id: this.state.screenObject.asset_id,
            status: objectConstants.STATUS_COMPLETE,
            asset_type_code: this.state.screenObject.asset_type_code,
            navigateToNextScreen: enable_feedback && progressionType !== objectConstants.GO_TO_TYPE_SCREEN,
            progressionType: progressionType,
            progressionGoToId: progressionGoToId,
            index: this.props.index,
            showProgression: this.state.showProgression,
        };

        this.props.callbacks.onObjectComplete(completionData);
    }

    showFeedback() {
        // console.log("showFeedback");
        if (this.state.responseData.currentStatus !== objectConstants.STATUS_COMPLETE) {
            this.setState({showFeedback: true, focusOnFeedback: true});
        }
    }

    checkResponses(){
        if(localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2){
            let parentScreen = this.props.callbacks.getSubScreenParent();
            let params = {

                bite_id: this.props.callbacks.getBiteId(),
                screen_id: this.props.callbacks.getScreenId(),
                parent_screen_id: appHelper.isDefined(parentScreen) ? parentScreen.screen_id : undefined,
                asset_id: this.state.screenObject.asset_id,
            };

            let interactionData = xAPIHelper.getMultipleChoiceIds(params);

            this.props.actions.getActvityStatement(interactionData).then((responseObj) => {

                if (appHelper.isDefined(responseObj.statement) && appHelper.isDefined(responseObj.statement.result.completion)) {



                    this.setState({
                        xApiResponseObj: Object.assign({},responseObj),
                        reviewMode: true,
                        propsUpdated: true,
                        responseData: Object.assign(
                            {}, this.state.responseData,
                            {
                                currentStatus: objectConstants.STATUS_COMPLETE,
                                displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW,
                            }
                        )
                    });
                }
            });
        }
    }

    getObjectStatus() {
        this.setState({checkObjectStatus: false});
        if (this.state.responseData.currentStatus !== objectConstants.STATUS_COMPLETE && this.state.usePreviousUserObjectData) {
            let screenStatus = userDataHelper.getObjectStatus(this.state.userData, this.props.screenObject.asset_id);
            if (screenStatus === objectConstants.STATUS_COMPLETE && this.state.screenObject.attempt_type === objectConstants.ATTEMPT_TYPE_FIRST) {
                this.setState({
                    reviewMode: true,
                    propsUpdated: true,
                    responseData: Object.assign(
                        {}, this.state.responseData,
                        {
                            currentStatus: objectConstants.STATUS_COMPLETE,
                            displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW,
                        }
                    )
                });
            } else {
                let objectUserData = {};
                if (this.state.status !== objectConstants.STATUS_COMPLETE) {
                    let subScreenParent = this.props.callbacks.getSubScreenParent();
                    let screen_id = this.props.callbacks.getScreenId();
                    if (appHelper.isDefined(subScreenParent)) {
                        objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
                    } else {
                        objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
                    }
                }

                if (objectUserData.status === objectConstants.STATUS_COMPLETE && this.state.screenObject.attempt_type === objectConstants.ATTEMPT_TYPE_FIRST) {
                    this.setState({
                        reviewMode: true,
                        propsUpdated: true,
                        responseData: Object.assign(
                            {}, this.state.responseData,
                            {
                                currentStatus: objectConstants.STATUS_COMPLETE,
                                displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW,
                            }
                        )
                    });
                }
            }
        }
    }

    setReviewMode() {
        //console.log(`setReviewMode`);
        let optionIds = appHelper.getObjectOptionIds(this.state.screenObject);
        let kpiUserData = userDataHelper.getUserResponseByOptionIds(this.state.userData, this.props.callbacks.getBiteId(), optionIds);
        //console.log(`optionIds`,optionIds);
        //console.log(`kpiUserData`,kpiUserData);
        let showResponse = false;

        if (appHelper.isDefined(kpiUserData)) {
            let checkedOptions = appHelper.getObjectCheckedOptionsByKpiHistoryOptions(kpiUserData.option_id);
            let options = [];
            _.forEach(this.state.screenObject.options, function (optionData, index) {
                let option = Object.assign({},optionData,{
                    answered: true,
                    is_correct: optionData.option_id === checkedOptions[index].option_id,
                    selected_option: checkedOptions[index],
                    default_option: checkedOptions[index]
                });
                options = dataHelper.immutablePush(options,option);
            });

            //console.log(`checkedOptions`,checkedOptions);
            let outcome = appHelper.getOrderingObjectOutcomeByKpiHistoryOptions(options);

            //console.log(`outcome`,outcome);

            if (appHelper.isDefined(outcome.dialogs) && outcome.dialogs.length > 0) {
                showResponse = true;
            }
            let responseData = Object.assign({}, this.state.responseData, {
                checkedOptions: options,
                outcome: outcome
            });

            let enable_feedback = outcome.enable_feedback && this.showOutcome();
            let show_feedback_after_completion = outcome.feedback_settings.show_feedback_after_completion && this.showOutcome();
            let hasBadges = appHelper.isDefined(outcome.badges) && outcome.badges.length > 0 && this.showOutcome();
            //console.log(`showProgression line 598`);
            this.setState(
                {
                    showProgression: !this.props.callbacks.hasNextObject(this.props.index) && enable_feedback && (!hasBadges || hasBadges && this.state.badgesCollected),
                    hasBadges: hasBadges,
                    badgesCollected: this.state.badgesCollected,
                    showFeedback: enable_feedback && show_feedback_after_completion,
                    handleCompletion: true,
                    showResponse: showResponse,
                    progression_label: outcome.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN ? this.state.try_again_label :  this.state.continue_label,
                    propsUpdated: false,
                    showOptions: true,
                    options: Object.assign([], options),
                    showCheckBtn: false,
                    responseData: responseData,
                    checkedForMissedOptions: true,
                    currentlyChecked: true,
                    allowShowFeedback:  enable_feedback && show_feedback_after_completion,
                    showCorrectResponseControls: !showResponse && outcome.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN && outcome.result !== "best" && outcome.feedback_settings.show_correct_answers_controls && this.state.screenObject.scoring_type !== objectConstants.SCORING_TYPE_REFLECTIVE,
                    isDragDisabled: true,
                }
            );
        }else if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
            let responseObj = Object.assign({}, this.state.xApiResponseObj);
            if (appHelper.isDefined(responseObj.statement)) {

                let responseString = responseObj.statement.result.response;
                let _responseArray = responseString.split("[,]");
                let responseArray = [];

                _.forEach(_responseArray, function (response, index) {
                    responseArray = dataHelper.immutablePush(responseArray,  response.split("[.]"));
                });

                responseArray.sort();

                let choices = [];
                let targets = [];
                let selectedOptions = [];
                for (let i = 0; i < responseArray.length; i++) {

                    //let responseString = responseArray[i];
                    let responseStringArray = responseArray[i];
                    let choice = -1;
                    let target = -1;

                    if(appHelper.isDefined(responseStringArray[0])){
                        choice = parseInt(responseStringArray[0]);
                        choices =  dataHelper.immutablePush(choices,choice);
                    }

                    if(appHelper.isDefined(responseStringArray[1])){
                        target = parseInt(responseStringArray[1]);
                        targets =  dataHelper.immutablePush(targets,target);
                    }

                    if (target !== -1) {
                        let optionDetails = appHelper.getOptionParentDetails(target);
                        if (appHelper.isDefined(optionDetails.option.option_id)) {
                            selectedOptions = dataHelper.immutablePush(selectedOptions, optionDetails.option);
                        }
                    }
                }

                if(selectedOptions.length > 0) {

                    let options = [];
                    _.forEach(this.state.screenObject.options, function (optionData, index) {
                        let option = Object.assign({},optionData,{
                            answered: true,
                            is_correct: optionData.option_id === selectedOptions[index].option_id,
                            selected_option: selectedOptions[index],
                            default_option: selectedOptions[index]
                        });
                        options = dataHelper.immutablePush(options,option);
                    });


                    let correctAnswers = appHelper.getTypeCount(options, "result", "best");
                    let incorrectAnswers = appHelper.getNotOfTypeCount(options, "result", "best");
                    let kpis = kpiHelper.averageKpis(options);
                    let outcome = {};
                    if (correctAnswers.length === this.state.correctAnswerCount && incorrectAnswers.length === 0) {
                        outcome = Object.assign({}, appHelper.getArrayObjectByKey(this.state.screenObject.outcomes, "result", "best"), {
                            kpis: kpis
                        });
                    } else {
                        if (correctAnswers.length > 0) {
                            outcome = Object.assign({}, appHelper.getArrayObjectByKey(this.state.screenObject.outcomes, "result", "ok"), {
                                kpis: kpis
                            });
                            if (!appHelper.isDefined(outcome.result)) {
                                outcome = Object.assign({}, appHelper.getArrayObjectByKey(this.state.screenObject.outcomes, "result", "poor"), {
                                    kpis: kpis
                                });
                            }
                        } else {
                            outcome = Object.assign({}, appHelper.getArrayObjectByKey(this.state.screenObject.outcomes, "result", "poor"), {
                                kpis: kpis
                            });
                        }
                    }

                    if (this.state.screenObject.scoring_type === objectConstants.SCORING_TYPE_REFLECTIVE) {
                        outcome = Object.assign({}, appHelper.getArrayObjectByKey(this.state.screenObject.outcomes, "result", "best"), {
                            kpis: kpis,
                            result: "reflective"
                        });
                    }

                    if (appHelper.isDefined(outcome.dialogs) && outcome.dialogs.length > 0) {
                        showResponse = true;
                    }

                    let responseData = Object.assign({}, this.state.responseData, {
                        checkedOptions: options,
                        outcome: outcome
                    });

                    let enable_feedback = outcome.enable_feedback && this.showOutcome();
                    let show_feedback_after_completion = outcome.feedback_settings.show_feedback_after_completion && this.showOutcome();

                    let hasBadges = appHelper.isDefined(outcome.badges) && outcome.badges.length > 0 && this.showOutcome();
                    //console.log(`showProgression line 679`);
                    this.setState(
                        {
                            showProgression: !this.props.callbacks.hasNextObject(this.props.index) && enable_feedback && (!hasBadges || hasBadges && this.state.badgesCollected),
                            hasBadges: hasBadges,
                            badgesCollected: this.state.badgesCollected,
                            handleCompletion: true,
                            showFeedback: enable_feedback && show_feedback_after_completion,
                            showResponse: showResponse,
                            progression_label: outcome.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN ? this.state.try_again_label : this.state.continue_label,
                            propsUpdated: false,
                            showOptions: true,
                            options: Object.assign([], options),
                            showCheckBtn: false,
                            responseData: responseData,
                            checkedForMissedOptions: true,
                            allowShowFeedback: enable_feedback && show_feedback_after_completion,
                            isDragDisabled: true,
                            currentlyChecked: true,
                            showCorrectResponseControls: !showResponse && outcome.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN && outcome.result !== "best" && outcome.feedback_settings.show_correct_answers_controls && this.state.screenObject.scoring_type !== objectConstants.SCORING_TYPE_REFLECTIVE,

                        }
                    );
                }else{
                    this.setState({
                        reviewMode: false,
                        propsUpdated: false,
                        usePreviousUserObjectData: false,
                        responseData: Object.assign(
                            {}, this.state.responseData,
                            {
                                currentStatus: objectConstants.STATUS_NOT_STARTED,
                                displayState: objectConstants.OBJECT_DISPLAY_STATE_INITIAL,
                            }
                        )
                    });
                }

            }else {
                this.setState({propsUpdated: false, usePreviousUserObjectData: false,});
            }
        }else{
            this.setState({
                reviewMode: false,
                propsUpdated: false,
                usePreviousUserObjectData: false,
                responseData: Object.assign(
                    {}, this.state.responseData,
                    {
                        currentStatus: objectConstants.STATUS_NOT_STARTED,
                        displayState: objectConstants.OBJECT_DISPLAY_STATE_INITIAL,
                    }
                )
            });
        }
    }

    reattempt() {
        let focusEl = this.refs[`${this.state.screenObject.asset_id}_questionOptions`];
        focusEl.focus();
        this.setOptions();
        this.setState(
            {
                showFeedback: false,
                hideFeedback: false,
                showCheckBtn: true,
                revealedOptions: dataHelper.immutableSplice(this.state.revealedOptions, 0, this.state.revealedOptions.length),
                enableCheckBtn: false,
                showOptions: true,
                showResponse: false,
                currentlyChecked: false,
                isDragDisabled: false,
                responseData: Object.assign(
                    {}, this.state.responseData,
                    {
                        currentAttempt: this.state.responseData.currentAttempt + 1,
                        currentStatus: objectConstants.STATUS_ATTEMPTED,
                        displayState: objectConstants.OBJECT_DISPLAY_STATE_RETRY,
                        outcome: Object.assign({}, {}),
                        checkedOptions: Object.assign([], [])

                    }
                )
            }
        );
    }

    onReviewObject(sourceId) {
        if(this.hasFeedbackToShow()) {
            let config = Object.assign({}, ORDERING_MATCHING_REVIEW_CONFIG,
                {
                    title: this.state.locale.label,
                    sourceId: sourceId
                }
            );
            //locale.title


            for (let i = 0; i < config.childComponents.length; i++) {
                let child = config.childComponents[i];
                child.componentProps = Object.assign({}, {
                    screenObject: this.state.screenObject,
                    responseData: Object.assign(
                        {}, this.state.responseData,
                        {
                            displayState: objectConstants.OBJECT_DISPLAY_STATE_REVIEW,
                            userSelections: Object.assign([], this.state.responseData.checkedOptions)
                        }
                    ),
                    callbacks: this.props.callbacks
                });
            }
            this.props.actions.setNewDialog(config);
        }
    }

    handleResponseComplete() {
        let enable_feedback = this.state.responseData.outcome.enable_feedback && this.showOutcome();
        //console.log(`showProgression line 774`);
        this.setState(
            {
                showFeedback: enable_feedback && this.state.responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW,
                focusOnFeedback: enable_feedback && this.state.responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW,
                hasBadges: appHelper.isDefined(this.state.responseData.outcome.badges) && this.state.responseData.outcome.badges.length > 0 && !enable_feedback,
                skipFeedback: !enable_feedback && this.state.responseData.outcome.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN,
                showProgression: !enable_feedback &&  this.state.responseData.outcome.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN,
                showCorrectResponseControls:  this.state.responseData.outcome.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN && this.state.responseData.outcome.result !== "best"
            }
        );
    }

    getStatusClass() {
        return this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW && appHelper.isDefined(this.state.responseData.outcome.feedback_settings) && this.state.responseData.outcome.feedback_settings.include_explore_feedback && this.hasFeedbackToShow() ? "complete" : "";
    }

    getTabIndex() {
        return this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW && appHelper.isDefined(this.state.responseData.outcome.feedback_settings) && this.state.responseData.outcome.feedback_settings.include_explore_feedback ? 0 : -1;
    }

    onPanelClick() {

        if (this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW && appHelper.isDefined(this.state.responseData.outcome.feedback_settings) && this.state.responseData.outcome.feedback_settings.include_explore_feedback && this.hasFeedbackToShow()) {
            this.onReviewObject(`question_wrapper_${this.state.screenObject.asset_id}`);
        }
    }

    onKeyboardPanelClick(event) {
        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            if (this.state.responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW && appHelper.isDefined(this.state.responseData.outcome.feedback_settings) && this.state.responseData.outcome.feedback_settings.include_explore_feedback) {
                this.onReviewObject(`question_wrapper_${this.state.screenObject.asset_id}`);
            }
        }
    }

    getMissedOptions() {
        this.setState({checkedForMissedOptions: false});
        let missedOptions = [];
        for (let o = 0; o < this.state.screenObject.options.length; o++) {
            let option = this.state.screenObject.options[o];
            let locale = appHelper.getLocalData(option);
            let optionCheckedIndex = appHelper.getArrayObjectIndexByKey(this.state.responseData.checkedOptions, "option_id", option.option_id);
            let optionObject = {
                result: option.result,
                className: optionCheckedIndex > -1 ? 'checked' : 'missed',
                option_text: locale.option,
                option_id: option.option_id
            };
            if (optionCheckedIndex === -1 && this.state.responseData.outcome.result !== objectConstants.RESULT_BEST && option.result === objectConstants.RESULT_BEST && this.state.responseData.outcome.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE) {
                missedOptions = dataHelper.immutablePush(missedOptions, optionObject);
            }
        }
        if (missedOptions.length > 0) {
            this.setState({
                missedOptions: Object.assign({}, this.state.missedOptions, {
                    show: true,
                    options: Object.assign([], missedOptions)
                })
            });
        }
    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    enableProgression(progression_label){
        let hasBadges = appHelper.isDefined(this.state.responseData.outcome.badges) && this.state.responseData.outcome.badges.length > 0 && this.showOutcome();
        let progressionType = appHelper.isDefined(this.state.responseData.outcome.progression_type) ? this.state.responseData.outcome.progression_type : undefined;
        let showProgression = (!hasBadges || this.state.showProgression);
        if(!this.props.callbacks.hasNextObject(this.props.index)){
            showProgression = ((!hasBadges || hasBadges && this.state.badgesCollected) || this.state.showProgression) && progressionType !== objectConstants.GO_TO_TYPE_SCREEN && this.state.responseData.outcome.progression !== objectConstants.OBJECT_PROGRESSION_TERMINAL;
        }
        //console.log(`showProgression line 854`);
        this.setState({
            showProgression: showProgression,
            hasBadges: hasBadges,
            progression_label: this.state.responseData.outcome.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN ? this.state.try_again_label :  this.state.continue_label,
        });
        this.props.callbacks.scrollToContinue();
    }

    onProgressionClicked(){
        let show_feedback_after_completion = this.state.responseData.outcome.feedback_settings.show_feedback_after_completion && this.showOutcome();
        let showFeedbackOnceComplete = show_feedback_after_completion && this.state.responseData.outcome.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN;
        let hideFeedback = !showFeedbackOnceComplete && (this.props.callbacks.hasNextObject(this.props.index) && this.state.responseData.outcome.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN);
        //console.log(`showProgression line 866`);
        this.setState({
            showProgression: false,
            hideFeedback: hideFeedback,

        });


        let enable_feedback = this.state.responseData.outcome.enable_feedback;

        if (!this.props.callbacks.hasNextObject(this.props.index) && this.state.responseData.outcome.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN) {
            this.props.callbacks.navigateToNextScreen();
        }else if(this.props.callbacks.hasNextObject(this.props.index) && !hideFeedback){
            this.handleResponse();
        }else if(this.state.responseData.outcome.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN){
            this.reattempt();
        }
    }

    onBadgeCollected() {
        let show_feedback_after_completion = this.state.responseData.outcome.feedback_settings.show_feedback_after_completion && this.showOutcome();
        let showFeedbackOnceComplete = this.state.showFeedback && show_feedback_after_completion && this.state.responseData.outcome.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN;
        this.setState({badgesCollected: true, showFeedback: showFeedbackOnceComplete});
        if(!this.props.callbacks.hasNextObject(this.props.index)) {
            //console.log(`showProgression line 890`);
            this.setState({
                showProgression: true,
                progression_label: this.state.responseData.outcome.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN ? this.state.try_again_label :  this.state.continue_label,
            });
            this.props.callbacks.scrollToContinue();
        }

        this.handleResponse();

    }

    toggleUserAnswers(event){
        event.stopPropagation();
        event.preventDefault();
        this.setState({showUserResponses: !this.state.showUserResponses});
    }

    onDragEnd(result){
        if(result.source !== null && result.destination !== null) {
            let options =  Object.assign([],this.state.options);
            let sourceOptionIndex = result.source.index;
            let sourceOption = this.state.options[sourceOptionIndex];

            //console.log(`sourceOption`, sourceOption.selected_option);

            let destinationOptionIndex = result.destination.index;
            let destinationOption = this.state.options[destinationOptionIndex];
            //console.log(`destinationOption`, destinationOption)

            destinationOption = Object.assign({},destinationOption,{
                selected_option: sourceOption.selected_option,
                answered: true,
                is_correct: destinationOption.option_id === sourceOption.selected_option.option_id
            });

            //console.log(`destinationOption`, destinationOption)


            if(sourceOptionIndex > destinationOptionIndex){
                //console.log(`change  answers after destination ${destinationOptionIndex} : start ${destinationOptionIndex + 1} - ${sourceOptionIndex} - selected answer index - 1`);
                let startIndex = destinationOptionIndex + 1;
                options = this.updateAnswersAfterDestination(options,startIndex,sourceOptionIndex);
            }else{
                //console.log(`change all answers after source ${destinationOptionIndex}  : start ${sourceOptionIndex} - ${destinationOptionIndex - 1} - selected answer index + 1`);
                let endIndex = destinationOptionIndex - 1;
                options = this.updateAnswersAfterSource(options, sourceOptionIndex, endIndex);
            }

            //console.log(`options`,options);

            options =  dataHelper.immutableSplice(options, destinationOptionIndex, 1, destinationOption);

            options = this.setAllOptionsToAnswered(options);

            let checkedOptions = this.getCheckedOptions(options);
            let hasNextOption = appHelper.isDefined(options[destinationOptionIndex + 1]);

            this.setState({
                options: Object.assign([],options),
                currentOption: hasNextOption ? options[destinationOptionIndex + 1] : destinationOption,
                enableCheckBtn: checkedOptions.length  === options.length,
                responseData: Object.assign({}, this.state.responseData,
                    {
                        checkedOptions: Object.assign([], checkedOptions),
                        initialised: true
                    }
                )
            });
        }
    }

    updateAnswersAfterDestination(options, startIndex, endIndex){
        let updatedOptions =  Object.assign([],this.state.options);
        for(let i = startIndex; i <= endIndex; i++){
            let option = options[i];
            let targetOption = options[i - 1];

            option = Object.assign({}, option,{
                selected_option: targetOption.selected_option,
                answered: true,
                is_correct: option.option_id === targetOption.selected_option.option_id
            });
            updatedOptions = dataHelper.immutableSplice(updatedOptions, i,1,option);
        }
        return updatedOptions;
    }

    updateAnswersAfterSource(options, startIndex, endIndex){
        let updatedOptions =  Object.assign([],this.state.options);
        for(let i = startIndex; i <= endIndex; i++){
            let option = options[i];
            let targetOption = options[i + 1];

            option = Object.assign({}, option, {
                selected_option: targetOption.selected_option,
                answered: true,
                is_correct: option.option_id === targetOption.selected_option.option_id
            });
            updatedOptions = dataHelper.immutableSplice(updatedOptions, i,1,option);
        }

        return updatedOptions;
    }

    getCheckedOptions(options){
        let checkedOptions = Object.assign([], this.state.responseData.checkedOptions);
        for(let i = 0; i < options.length; i++){
            let option = options[i];
            if(option.answered) {
                let checkedOptionIndex = appHelper.getArrayObjectIndexByKey(checkedOptions, "option_id", option.option_id);
                if (checkedOptionIndex == -1) {
                    checkedOptions = dataHelper.immutablePush(checkedOptions, option);
                } else {
                    checkedOptions = dataHelper.immutableSplice(checkedOptions, checkedOptionIndex, 1, option);
                }
            }
        }

        checkedOptions.sort(function (a, b) {
            if (a.option_id < b.option_id) return -1;
            if (a.option_id > b.option_id) return 1;
            return 0;
        });

        //console.log(`checkedOptions`,checkedOptions);

        return checkedOptions;
    }

    setAllOptionsToAnswered(options){
        let updatedOptions =  Object.assign([],this.state.options);
        for(let i = 0; i < options.length; i++){
            let option = options[i];
            option = Object.assign({}, option, {
                answered: true,
                is_correct: option.option_id === option.selected_option.option_id
            });
            updatedOptions = dataHelper.immutableSplice(updatedOptions, i,1,option);
        }

        return updatedOptions;
    }

    render() {
        return (
            <div className="learner-action">
                <p className="hidden-el">{this.state.multiple_choice_question_label}</p>
                {
                    appHelper.isDefined(this.props.characterPose) && appHelper.isDefined(this.props.characterPose.src) && this.props.characterPose.src.length > 0
                        ?
                        <div className={`content-character-expression`}>
                            <img src={this.getImagePath(this.props.characterPose.src)} alt=""/>
                        </div>
                        :
                        null
                }
                <div className={`question-wrapper ${this.getStatusClass()}`} tabIndex={this.getTabIndex()}
                     id={`question_wrapper_${this.state.screenObject.asset_id}`}
                     role="presentation" onClick={this.onPanelClick} onKeyDown={this.onKeyboardPanelClick}>
                    {
                        this.state.screenObject.prompt_type !== objectConstants.PROMPT_TYPE_SHOW_NO_PROMPT && this.state.screenObject.show_prompt
                            ?
                            this.state.screenObject.prompt_settings.class_name === objectConstants.DIALOG
                                ?

                                <div className="object-container">
                                    <DialogPrompt character_name={this.state.character_name}
                                                  screenObject={this.state.screenObject}
                                                  onComplete={this.onPromptRevealed}/>
                                </div>
                                :
                                <QuestionPrompt screenObject={this.state.screenObject} onComplete={this.onPromptRevealed}/>
                            :
                            null
                    }

                    {this.state.showOptions
                        ?
                        <div className="text-center">
                            <div className={`ordering-option-list theme-active ${this.state.labelWidth === 0 ? 'hidden-el' : ''}`}
                                 id={`${this.state.screenObject.asset_id}_questionOptions`}
                                 ref={`${this.state.screenObject.asset_id}_questionOptions`}
                            >
                                <DragDropContext onDragEnd={this.onDragEnd}>
                                    <Droppable droppableId="droppableObjects" type="bites" isDropDisabled={this.state.isDragDisabled} >
                                        {(provided, snapshot) => (
                                            <div
                                                className="drop-area"
                                                ref={provided.innerRef}
                                                style={dndHelper.getListStyle(snapshot.isDraggingOver)}
                                                {...provided.droppableProps}

                                            >
                                                {this.state.options.map(option =>

                                                    <Option key={`option_${option.option_id}`}
                                                            asset_type_code={this.state.screenObject.asset_type_code}
                                                            option={option}
                                                            currentOption={this.state.currentOption}
                                                            setCurrentOption={this.setCurrentOption}
                                                            asset_id={this.state.screenObject.asset_id}
                                                            questionChecked={this.state.questionChecked}
                                                            currentlyChecked={this.state.currentlyChecked}
                                                            onOptionClick={this.onOptionClick}
                                                            responseData={this.state.responseData}
                                                            onAttemptComplete={this.showFeedback}
                                                            onOptionRevealed={this.onOptionRevealed}
                                                            onShowReview={this.onReviewObject}
                                                            index={appHelper.getObjectOptionIndex(this.state.screenObject.options, option.option_id)}
                                                            showCorrectResponseControls={this.state.showCorrectResponseControls}
                                                            showUserResponses={this.state.showUserResponses}
                                                            callbacks={this.props.callbacks}
                                                            scoring_type={this.state.screenObject.scoring_type}
                                                            labelWidth={this.state.labelWidth}
                                                            longestOption={this.state.longestOption}
                                                            isDragDisabled={this.state.isDragDisabled}
                                                            showOutcome={this.showOutcome()}
                                                            dragHandleProps={provided.dragHandleProps}
                                                    />

                                                )}
                                                {provided.placeholder}
                                            </div>
                                        )}
                                    </Droppable>


                                </DragDropContext>
                            </div>
                        </div>
                        :
                        null
                    }

                    {this.state.showCheckBtn
                        ? <Button label={this.state.submit_label}
                                  id={`${this.state.screenObject.asset_id}_check_button`}
                                  isDisabled={!this.state.enableCheckBtn}
                                  onRevealed={this.props.callbacks.scrollToTop}
                                  onClick={this.checkAnswers}/>
                        : null
                    }

                    {this.state.showResponse || this.state.showFeedback || this.state.showCorrectResponseControls
                        ?
                        <div ref={`feedback_wrapper_${this.state.screenObject.asset_id}`}
                             id={`feedback_wrapper_${this.state.screenObject.asset_id}`}
                             role="article"
                             tabIndex={0}
                             className="feedback-focus">
                            {this.state.showResponse
                                ?
                                <Conversation asset_id={this.state.screenObject.asset_id}
                                              option_id={this.state.responseData.outcome.option_id}
                                              dialogs={this.state.responseData.outcome.dialogs}
                                              callbacks={this.props.callbacks}
                                              onComplete={this.handleResponseComplete}/>
                                :
                                null
                            }

                            {this.state.showCorrectResponseControls && this.showOutcome()
                                ?
                                <div>
                                    <Button label={this.state.showUserResponses ? this.state.show_correct_answers_label : this.state.show_my_answers_label}
                                            id={`${this.state.screenObject.asset_id}_showCorrectAnswersButton`}
                                            onClick={this.toggleUserAnswers}/>
                                </div>
                                :
                                 null
                            }

                            {this.state.showFeedback && this.state.allowShowFeedback
                                ? <Feedback screenObject={this.state.screenObject}
                                            options={this.state.screenObject.options}
                                            asset_id={this.state.screenObject.asset_id}
                                            responseData={this.state.responseData}
                                            onComplete={this.handleResponse}
                                            onShowReview={this.onReviewObject}
                                            onEnableProgression={this.enableProgression}
                                            hideFeedback={this.state.hideFeedback}
                                            callbacks={this.props.callbacks}
                                            index={this.props.index}
                                />
                                : null
                            }
                        </div>
                        :
                        null
                    }
                    {(this.state.showResponse || this.state.showFeedback) && this.state.hasBadges
                        ?
                        <br/>
                        :
                        null
                    }
                    {
                        this.state.hasBadges
                            ?
                            <div className="badge-wrapper">
                                {this.state.responseData.outcome.badges.map(badge =>
                                    <BadgeCollect key={badge.badge_id} badge_id={badge.badge_id}
                                                  bite_id={this.props.callbacks.getBiteId()}
                                                  asset_id={this.state.screenObject.asset_id}
                                                  onCollected={this.onBadgeCollected}
                                                  animate={this.state.animateBadge}/>
                                )}
                            </div>
                            : null
                    }
                </div>
                {this.state.showProgression
                    ?
                    <Button label={this.state.progression_label} id={`${this.state.screenObject.asset_id}_button`}
                            onClick={this.onProgressionClicked}/>
                    : null

                }
            </div>
        );
    }
}

OrderingMatching.propTypes = {
    screenObject: PropTypes.object.isRequired,
    callbacks: PropTypes.object.isRequired,
    characterPose: PropTypes.object,
    index: PropTypes.number,
    contentData: PropTypes.object.isRequired,
    trackingData: PropTypes.object.isRequired,
    userData: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired
};

OrderingMatching.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        contentData: state.contentData,
        trackingData: state.trackingData,
        userData: state.userData

    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions, dialogPopupActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(OrderingMatching);



/** WEBPACK FOOTER **
 ** ./src/components/objects/multipleChoice/orderingMatching/OrderingMatching.js
 **/